import React, { useRef, useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '..';
import { set, ref } from 'firebase/database';
import { sendEmailVerification } from 'firebase/auth';
import { Link } from 'react-router-dom';

const SignUp = () => {
    const email = useRef(null);
    const password = useRef(null);
    const name = useRef(null);
    const [showError, setShowError] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        // サインアップ処理をここに追加
        console.log('Form submitted:', name.current.value, email.current.value, password.current.value);

        // Firebase のメールアドレスとパスワードでの新規登録処理
        try {
            await createUserWithEmailAndPassword(auth, email.current.value, password.current.value)
            .then(async (userCredential) => {
                // Signed in 
                const user = userCredential.user;

                // メールアドレス確認メールを送信
                sendEmailVerification(user)
                .then(() => {
                    // Email sent.
                    console.log('Email sent:', user.email);

                    //書き込み
                    set(ref(db, 'users/' + user.uid), {
                        username: name.current.value,
                        email: email.current.value
                    })
                    .then(() => {
                        navigate('/');
                    });
                });
            });
            
        } catch (error) {
            // ログイン失敗時の処理
            setShowError(true);
            console.error('Sign up failed:', error);
        }
    };

  return (
    <div className="text-center my-6 mx-3">
        <div className="py-5">
            <h1 className="text-4xl tracking-widest mb-3">電鬼 2</h1>
            <p className="text-lg text-gray-500">大規模鬼ごっこ運営Webアプリ</p>
        </div>

        {/* サインアップ */}
        <form className="md:w-1/3 mx-auto my-6 p-6 bg-white rounded-3xl shadow" onSubmit={(e) => handleSubmit(e)}>
            <h2 className="text-center text-2xl mb-4 ">アカウントを作成</h2>
            <div className="mb-4">
                <label htmlFor="name" className="block text-sm text-gray-700">
                    ニックネーム
                </label>
                <input type="text" id="name" name="name" ref={name} className="mt-1 p-2 w-full border border-gray-300 rounded-md" />
            </div>
            <div className="mb-4">
                <label htmlFor="email" className="block text-sm text-gray-700">
                    メールアドレス
                </label>
                <input type="email" id="email" name="email" ref={email} className="mt-1 p-2 w-full border border-gray-300 rounded-md" />
            </div>
            <div className="mb-6">
                <label htmlFor="password" className="block text-sm text-gray-700">
                    パスワード
                </label>
                <input type="password" id="password" name="password" ref={password} className="mt-1 p-2 w-full border border-gray-300 rounded-md" />
            </div>

            <div className={"mb-6"}>
                <label className='text-sm mb-2 block text-gray-700'>確認事項</label>

                <div className='text-left text-base'>
                    <input type='checkbox' id='agree' name='agree' className='form-checkbox rounded text-purple-600' />
                    <label htmlFor='agree' className='text-gray-700 ms-2'><Link to="/info/terms" target="_blank" className='underline text-purple-600 hover:text-purple-700'>利用規約</Link>に同意する</label>
                </div>

                <div className='text-left text-base'>
                    <input type='checkbox' id='agree2' name='agree2' className='form-checkbox rounded text-purple-600' />
                    <label htmlFor='agree2' className='text-gray-700 ms-2'><Link to="/info/privacy" target="_blank" className='underline text-purple-600 hover:text-purple-700'>プライバシーポリシー</Link>に同意する</label>
                </div>
            </div>

            <div className={"mb-6 text-red-600 text-sm " + (!showError && "hidden")}>
                <p>登録に失敗しました。入力内容に間違いはありませんか？</p>
            </div>

            <button type="submit" className="w-full p-2 bg-purple-500 text-white rounded-md hover:bg-purple-700"><i className="bi bi-check-lg me-2"></i>登録</button>
        </form>

    </div>
  )
}

export default SignUp